module.exports = __webpack_public_path__ + "static/media/icon-play-circle.387a7f08.svg";